export const tags = {
  Activism: '✊',
  Art: '🎨',
  Blockchain: '🔗',
  'Books & blogs': '📚',
  Career: '💼',
  Collaboration: '🤝',
  Commerce: '🛒',
  Culture: '🎎',
  DAO: '🚀',
  DeFi: '📈',
  Design: '🧩',
  DIY: '🔨',
  Environment: '🌿',
  Education: '🎒',
  Entertainment: '🍿',
  Ethereum: 'Ξ',
  Event: '🗓',
  Fantasy: '🧙‍♂️',
  Fashion: '🧦',
  Food: '🌶',
  Gaming: '🎮',
  Global: '🌍',
  Health: '🧠',
  Hobby: '📐',
  Innovation: '🧪',
  Language: '📜',
  Lifestyle: '✨',
  Local: '📍',
  Love: '❤️',
  Markets: '💎',
  'Movies & TV': '🎞',
  Music: '🎶',
  News: '🗞',
  NFT: '🖼',
  'Non-profit': '🙏',
  NSFW: '🍆',
  Org: '🏢',
  Pets: '🐶',
  Play: '🎲',
  Podcast: '🎙️',
  Politics: '🗳️',
  Product: '🍱',
  Psyche: '🍁',
  Privacy: '👻',
  Security: '🔒',
  Social: '☕',
  'Software dev': '👩‍💻',
  Sports: '⚽️',
  Tech: '📱',
  Travel: '🗺',
  Vehicles: '🚕',
  Web3: '🌐',
}
